import $ from 'jquery';
import loadScript from './loader';
import isTouch from '../exports/touch-detect';

const defaultOptions = {
  cc_load_policy: 1,
  iv_load_policy: 3,
  modestbranding: 1,
  playsinline: 1,
  controls: 1,
  showinfo: 0,
  ecver: 2,
  fs: 1,
  rel: 0,
};

export default function embedYoutube(uniqueKey, options) {
  const playerOptions = {
    ...defaultOptions,
    ...options,
  };
  const $player = $(`[data-player="${uniqueKey}"]`);
  const $playerElement = $player.find('iframe, [data-replace]');
  const youtubeKey = $player.find('[data-video-id]').attr('data-video-id');
  loadScript({url: 'https://www.youtube.com/iframe_api'});

  const playerPromise = window.youtubeLoaderPromise.then(function() {
    let player = new window.YT.Player($playerElement[0], {
      videoId: youtubeKey,
      playerVars: {
        ...playerOptions,
      },
    });
    $player.on('pause', function() {
      try {
        if (player.pauseVideo) {
          player.pauseVideo();
        }
      } catch (e) {
        console.warn(e);
      }
    });
    $player.on('play-desktop', function() {
      if (!isTouch()) {
        $player.trigger('play');
      }
    });
    $player.on('play', function() {
      try {
        if (player.playVideo) {
          player.playVideo();
        } else {
          player.addEventListener('onReady', function(event) {
            event.target.playVideo();
          });
        }
      } catch (e) {
        console.warn(e);
      }
    });
    $player.on('destroy', function() {
      try {
        if (player.destroy) {
          player.destroy();
        }
      } catch (e) {
        console.warn(e);
      }
    });
    return player;
  }).catch(function(err) {
    console.error(err);
  });
  return playerPromise;
}

window.youtubeLoaderPromise = new Promise((resolve) => {
  window.onYouTubeIframeAPIReady = function() {
    resolve();
  };
});
